import { c as _c } from "react/compiler-runtime";
/**
 * @Author: JulienBigot7 julien@generation-internet.biz
 * @Date: 2024-10-08 12:01:03
 * @LastEditors: JulienBigot7 julien@generation-internet.biz
 * @LastEditTime: 2024-12-10 11:04:45
 * @FilePath: src/app/(main)/_public_components/map-cookie-fallback.tsx
 * @Description: 这是默认设置,可以在设置》工具》File Description中进行配置
 */

import React from "react";
import { twMerge } from "tailwind-merge";
function MapCookieFallback(t0) {
  const $ = _c(6);
  const {
    className
  } = t0;
  const handleClick = _temp;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("absolute text-center text-sm md:text-lg flex gap-6 flex-col items-center justify-center inset-0 bg-light-grey z-10 md:mx-8 md:mb-8", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p>Vous avez refusé les cookies, par conséquent la carte localisant <br />{" "}les Clubs d'Affaires Dynabuy ne s'affiche pas.</p>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p>Pour afficher la carte,{" "}<button onClick={handleClick} className="font-bold underline cursor-pointer inline-block" type="button">merci d'accepter les cookies</button></p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
function _temp() {
  if (typeof window !== "undefined" && window.tarteaucitron) {
    ;
    try {
      window.tarteaucitron.userInterface.openPanel();
      return;
    } catch (t0) {
      const error = t0;
      console.error("Error using tarteaucitron API:", error);
    }
  }
  const citronModal = document.getElementById("tarteaucitron");
  const tarteaucitronBack = document.getElementById("tarteaucitronBack");
  if (!citronModal || !tarteaucitronBack) {
    const tarteaucitronManager = document.getElementById("tarteaucitronManager");
    if (tarteaucitronManager) {
      tarteaucitronManager.click();
      return;
    }
    const event = new CustomEvent("tarteaucitron.openPanel");
    document.dispatchEvent(event);
    return;
  }
  citronModal.style.opacity = "1";
  citronModal.style.display = "block";
  tarteaucitronBack.style.opacity = ".7";
  tarteaucitronBack.style.display = "block";
}
export default MapCookieFallback;